import React, { useEffect, useRef, useState } from 'react'
import { initializeZoom } from '../utils/zoomSLD';

const DEFAULT_ZOOM_STATE = {
  canZoomIn: true,
  canZoomOut: true,
  isDefault: true
};

const SldContainer = ({children, siteType}) => {
  const containerRef = useRef(null);
  const zoomApiRef = useRef(null);
  const activeSvgRef = useRef(null);
  const [zoomState, setZoomState] = useState(DEFAULT_ZOOM_STATE);

  useEffect(() => {
    const svgContainer = containerRef.current;

    if (!svgContainer) {
      return undefined;
    }

    const findTargetSvg = () => (
      svgContainer.querySelector('#genset-pvbess-sld') || svgContainer.querySelector('svg')
    );

    const initializeForSvg = (targetSvg) => {
      if (!targetSvg) {
        return;
      }

      if (activeSvgRef.current === targetSvg) {
        return;
      }

      zoomApiRef.current?.destroy();
      const zoomApi = initializeZoom(svgContainer, targetSvg, { onChange: setZoomState });
      zoomApiRef.current = zoomApi;
      activeSvgRef.current = targetSvg;
      setZoomState(zoomApi.getState());
    };

    initializeForSvg(findTargetSvg());

    const observer = new MutationObserver(() => {
      const nextSvg = findTargetSvg();

      if (!nextSvg && activeSvgRef.current) {
        zoomApiRef.current?.destroy();
        zoomApiRef.current = null;
        activeSvgRef.current = null;
        setZoomState(DEFAULT_ZOOM_STATE);
        return;
      }

      initializeForSvg(nextSvg);
    });

    observer.observe(svgContainer, { childList: true, subtree: true });

    const handleKeyDown = (event) => {
      const zoomApi = zoomApiRef.current;

      if (!zoomApi) {
        return;
      }

      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        zoomApi.zoomIn();
      } else if (event.key === '-') {
        event.preventDefault();
        zoomApi.zoomOut();
      } else if (event.key.toLowerCase() === 'r') {
        event.preventDefault();
        zoomApi.resetTransform();
      }
    };

    svgContainer.addEventListener('keydown', handleKeyDown);

    return () => {
      observer.disconnect();
      svgContainer.removeEventListener('keydown', handleKeyDown);
      zoomApiRef.current?.destroy();
      zoomApiRef.current = null;
      activeSvgRef.current = null;
      setZoomState(DEFAULT_ZOOM_STATE);
    };
  }, [siteType]);

  const handleZoomIn = () => {
    zoomApiRef.current?.zoomIn();
  };

  const handleZoomOut = () => {
    zoomApiRef.current?.zoomOut();
  };

  const handleReset = () => {
    zoomApiRef.current?.resetTransform();
  };

  return (
    <div
      id="SLD-Image"
      // ref={containerRef}
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12  px-0 sld-zoom-container"
      tabIndex="0"
      aria-label="SVG zoomable canvas"
    >
   {  false && <div
        className="sld-zoom-controls"
        role="group"
        aria-label="Zoom controls"
        data-sld-zoom-control="true"
      >
        <button
          id="zoom-in"
          type="button"
          className="sld-zoom-button"
          aria-label="Zoom in"
          onClick={handleZoomIn}
          disabled={!zoomState.canZoomIn}
        >
           +
        </button>
        <button
          id="zoom-out"
          type="button"
          className="sld-zoom-button"
          aria-label="Zoom out"
          onClick={handleZoomOut}
          disabled={!zoomState.canZoomOut}
        >
           -
        </button>
        <button
          id="reset"
          type="button"
          className="sld-zoom-button"
          aria-label="Reset zoom and pan"
          onClick={handleReset}
          disabled={zoomState.isDefault}
        >
          <span className="sld-zoom-icon" aria-hidden="true">{'\u21BB'}</span>
          
        </button>
      </div>}
      {children}
    </div>
  )
}

export default SldContainer